import { ActionIcon, Group, Text, useMantineTheme } from '@mantine/core';
import { useEffect, useState } from 'react';
import { AddFilterButton, FilterBadge } from '../../components';
import { Reload } from 'tabler-icons-react';
import { IFilterItem } from '../../models';

interface Props {
  filterOptions: IFilterItem[];
  initialFilters?: IFilterItem[];
  onChange: (newFilters: IFilterItem[]) => void;
}

export const FilterRibbon = (props: Props) => {
  const theme = useMantineTheme();

  const [selectedFilters, setSelectedFilters] = useState<IFilterItem[]>(props.initialFilters ?? []);

  const filterBadges = selectedFilters.map((a) => (
    <FilterBadge
      key={a.id}
      filter={a}
      onRemove={() => {
        setSelectedFilters((b) => b.filter((c) => c !== a));
      }}
    />
  ));

  useEffect(() => {
    props.onChange(selectedFilters);
  }, [selectedFilters]);

  return (
    <Group style={{ justifyContent: 'space-between', flexWrap: 'nowrap' }}>
      <Group
        spacing={theme.spacing.xs}
        align="center"
        style={{ position: 'relative', flexWrap: 'nowrap', justifyContent: 'center' }}
      >
        <Text mt={-2} size={theme.fontSizes.sm} style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>
          Equipment:
        </Text>
        <Group spacing={5}>
          {filterBadges}
          <AddFilterButton
            filterOptions={props.filterOptions}
            selectedFilters={selectedFilters}
            onFilterSelected={(newFilter) => {
              setSelectedFilters((a) => [...a, newFilter]);
            }}
          />
        </Group>
      </Group>
      <Group noWrap>
        <Group spacing={5} style={{ flexWrap: 'nowrap' }}>
          <ActionIcon variant="subtle">
            <Reload
              size={20}
              onClick={() => {
                setSelectedFilters([]);
              }}
            />
          </ActionIcon>
        </Group>
      </Group>
    </Group>
  );
};
